import { render, staticRenderFns } from "./SysApiMockValueForm.vue?vue&type=template&id=545a8b9d&"
import script from "./SysApiMockValueForm.vue?vue&type=script&lang=js&"
export * from "./SysApiMockValueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports